import { ReactLazyPreload } from '@Components/utils/RouterUtils'

const AlarmModifyPage = ReactLazyPreload(() => import(/* webpackChunkName: 'ModifyPage' */ './ModifyPage'))
export default {
  path: '/modify/:articleNo',
  exact: true,
  component: AlarmModifyPage,
}
